import React, { useRef, useState, useEffect } from "react";

type TInfiniteScrollProps = {
  onBottomHit: () => void;
  isLoading: boolean;
  hasMoreData: boolean;
  loadOnMount: boolean;
  children: React.ReactNode;
};

function isBottom(
  ref: React.RefObject<HTMLDivElement>,
  parent: HTMLElement | null,
) {
  if (!ref.current || !parent) {
    return false;
  }
  const rect = ref.current.getBoundingClientRect();
  const parentRect = parent.getBoundingClientRect();
  return rect.bottom <= parentRect.bottom;
}

export const InfiniteScroll: React.FC<TInfiniteScrollProps> = ({
  onBottomHit,
  isLoading,
  hasMoreData,
  loadOnMount,
  children,
}) => {
  const [initialLoad, setInitialLoad] = useState(true);
  const contentRef = useRef<HTMLDivElement>(null);
  const mainContainer = document.getElementById("main");
  useEffect(() => {
    if (loadOnMount && initialLoad) {
      onBottomHit();
      setInitialLoad(false);
    }
  }, [onBottomHit, loadOnMount, initialLoad]);

  useEffect(() => {
    const onScroll = () => {
      if (!isLoading && hasMoreData && isBottom(contentRef, mainContainer)) {
        onBottomHit();
      }
    };
    if (mainContainer) mainContainer.addEventListener("scroll", onScroll);
    return () => {
      if (mainContainer) mainContainer.removeEventListener("scroll", onScroll);
    };
  }, [onBottomHit, isLoading, hasMoreData, mainContainer]);

  return <div ref={contentRef}>{children}</div>;
};
